var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"648ba448fec710209ba0e11a0322792d2bcc5235"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

// Sentry.init({
//   dsn: SENTRY_DSN || 'https://56efb9202f554e08b6f18390724cf75a@o1104713.ingest.sentry.io/6143116',
//   tracesSampleRate: 1.0
// });

if (['dev','prod'].includes(process.env.STAGE)) {
  Sentry.setTag('stage', process.env.STAGE);
  Sentry.init({
    dsn: SENTRY_DSN || 'https://56efb9202f554e08b6f18390724cf75a@o1104713.ingest.sentry.io/6143116',
    tracesSampler: samplingContext => {
    // console.log('samplingContext - client', samplingContext);
    if (samplingContext.request) {
      return 1;
    }

    if (['pageload','navigation'].includes(samplingContext.transactionContext?.op)) {
      return 0.01;
    }

    return 0.1;
  }
  });
}